import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MASKS } from 'ng-brazil';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-desconto-individual-modal',
  templateUrl: './desconto-individual-modal.component.html',
  styleUrls: ['./desconto-individual-modal.component.scss']
})
export class DescontoIndividualModalComponent implements OnInit {

  public config: PerfectScrollbarConfigInterface = {};

  valor = 0;
  desconto = 0;
  percentual = 0;
  valorTotalItens = 0;
  valorTotalItensComDesconto = 0;
  descontoMaximo = 0;
  podeAplicar = false;
  valorComDesconto = 0;
  aplicarParaTodos = false;

  public MASKS = MASKS;

  constructor(public dialogRef: MatDialogRef<DescontoIndividualModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private utilitarioService: UtilitarioService) { }

  ngOnInit() {
    this.valor = this.data.valor;
    this.desconto = this.data.desconto;
    this.percentual = this.data.percentual;
    this.valorTotalItens = this.data.valorTotalItens;
    this.valorTotalItensComDesconto = this.data.valorTotalItensComDesconto;
    this.descontoMaximo = this.data.descontoMaximo;

    if (this.data.descontoAplicadoParaTodos !== null && this.data.descontoAplicadoParaTodos !== undefined) {
      this.aplicarParaTodos = this.data.descontoAplicadoParaTodos;
    }

    this.validarDescontoMaximo();
  }

  atualizaDesconto(tipo) {

    if (tipo === 0) {
      if (!this.percentual) {
        this.desconto = 0;
        this.percentual = 0;
      } else {
        const percentualCalculado = Number(((Number(this.desconto) * 100) / Number(this.valor)).toFixed(4));

        if (percentualCalculado !== this.percentual) {
          this.desconto = Number(((Number(this.valor) * this.percentual) / 100).toFixed(2));
        }
      }
    } else {
      if (!this.desconto) {
        this.percentual = 0;
        this.desconto = 0;
      } else {
        this.percentual = Number(((Number(this.desconto) * 100) / Number(this.valor)).toFixed(4));
      }
    }

    this.validarDescontoMaximo();
  }

  validarDescontoMaximo() {

    if (this.aplicarParaTodos) {
      this.podeAplicar = this.percentual <= this.descontoMaximo;
    } else {
      this.valorComDesconto = this.valor - this.desconto;
      // vtotalitens - 100
      // vcomDesc - x

      const totalDesconto = this.valorTotalItensComDesconto + this.valorComDesconto;
      const diferenca = Number((this.valorTotalItens - totalDesconto).toFixed(2));
      const percentual = Number((100 * diferenca / this.valorTotalItens).toFixed(4));
      const valorMaximo = Number((this.valorTotalItens * this.descontoMaximo / 100).toFixed(2));

      this.podeAplicar = percentual < this.descontoMaximo || this.utilitarioService.compararDescontos(percentual, this.descontoMaximo) || diferenca <= valorMaximo;
    }

    if (!this.podeAplicar) {
      swal({
        title: 'ATENÇÃO!!',
        html: 'Desconto acima do permitido: <b>' + this.descontoMaximo.toLocaleString() + '(Percentual Geral)',
        type: 'warning',
        confirmButtonClass: 'btn btn-warning',
        buttonsStyling: false,
        allowEnterKey: false
      }).then((result) => {

      });
    }

  }

  aplicar() {
    this.dialogRef.close({ desconto: this.desconto, percentual: this.percentual, valor: this.valorComDesconto, aplicarParaTodos: this.aplicarParaTodos });
  }

  fechar() {
    this.dialogRef.close();
  }

  isPositive(event: any) { return event.key === '-' ? false : true; }
}
